import React from "react";
import { ExternalLink } from "lucide-react";
import { track } from "@/lib/analytics";

const base = "inline-flex items-center gap-2 rounded-full font-display font-extrabold uppercase tracking-wide text-base px-6 py-3 hover:scale-[1.03] transition-transform duration-200";

export default function OrderButtons({ ordering }) {
  const o = ordering || {};
  const links = [
    { url: o.glovo_url, label: "ORDINA SU GLOVO", event: "glovo_click", id: "glovo", solid: true },
    { url: o.justeat_url, label: "ORDINA SU JUST EAT", event: "justeat_click", id: "justeat", solid: true },
    { url: o.ordina_url, label: o.ordina_label || "ORDINA QUI", event: "order_here_click", id: "ordina-qui" },
    { url: o.ritira_url, label: o.ritira_label || "RITIRA QUI", event: "pickup_click", id: "ritira-qui" },
  ].filter((l) => l.url);
  if (!links.length) return null;
  return (
    <div id="ordina" className="mt-4 flex flex-wrap gap-3" data-testid="order-buttons">
      {links.map((l) => (
        <a
          key={l.id}
          href={l.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track(l.event, {})}
          className={`${base} ${l.solid ? "bg-[#0C0C0C] text-[#FFC20E]" : "border-2 border-[#0C0C0C] text-[#0C0C0C]"}`}
          data-testid={`order-btn-${l.id}`}
        >
          {l.label} <ExternalLink size={16} />
        </a>
      ))}
    </div>
  );
}
